module.exports = __webpack_public_path__ + "assets/logo.2718f1ad.svg";